import AdaptiveArea from './AdaptiveArea';

export default AdaptiveArea;
